import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/observable/of';
import { PageContents } from '../models/page-contents';
import { environment } from '../../environments/environment';

@Injectable()
export class AppContentsService {
    private pageName: string;
    private httpHeaders: HttpHeaders;
    private httpParams: HttpParams;
    private pageContents$: BehaviorSubject<PageContents>;

    constructor(private http: HttpClient) {
        this.init();
    }

    init(): void {
        /* Common headers */
        this.httpHeaders = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': environment.apiKey,
            'X-PhiBor-App': environment.phiborApp
        });

        /* Common http params */
        this.httpParams = new HttpParams();

        /* Observables on page contents */
        this.pageContents$ = new BehaviorSubject<PageContents>(<PageContents>{});
    }

    /* Single page contents API call */
    private loadPageContents(): void {
        this.http.get<PageContents[]>(
            environment.endpoints.admin + '/fec_pages?name=' + this.pageName,
            {
                headers: this.httpHeaders,
                params: this.httpParams
            })
            .subscribe(
                pageContents => {
                    if (pageContents && pageContents.length > 0) {
                        this.pageContents$.next(pageContents.shift());
                    }
                },
                error => this.pageContents$.error(error)
            );
    }

    getPageContents(pageName: string): Observable<PageContents> {
        if (pageName !== this.pageName) {
            this.pageName = pageName;
            this.loadPageContents();
        }
        return this.pageContents$.asObservable();
    }

//    getHelpContent(pageName: string, helpLabel: string): Observable<HelpContent> {
//        return <Observable<HelpContent>> Observable.create(helpContent$ => {
//            this.getPageContents(pageName).subscribe(
//                pageContents => {
////                    if (pageContents.helpContents) {
////                        helpContent$.next(
////                            pageContents.helpContents.find(
////                                function (helpContent: HelpContent) {
////                                    return helpContent.label === helpLabel;
////                                }
////                            )
////                        );
//                        helpContent$.complete();
////                    }
//                },
//                err => helpContent$.error(err)
//            );
//        });
//    }

}



// WEBPACK FOOTER //
// ./src/app/services/app-contents.service.ts